var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('smart-block',{attrs:{"link":"https://otahuhumainstreet.co.nz/news/","heading":"Otahuhu News"}}),_c('smart-block',{attrs:{"heading":"Promotions"}}),_c('smart-block',{attrs:{"heading":"Events"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }